enum TicketPriority {
    Blocking = " Blocking",
    High = "High",
    Normal = "Normal",
    Low = "Low"
}

export default TicketPriority;